import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FullPageLayout from '../../components/layouts/FullPageLayout';
import { signIn, signInFlow, unauthenticated } from '../../store/actions/auth';
import SignIn from '../../components/pages/SignIn';
import token from '../../utils/token';
import Spinner from '../../components/common/Spinner';
import { verifyEmailOtp, resendEmailOtp } from '../../store/actions/otp';
import { VALIDATED } from '../../constants/auth';

function SignInContainer(props) {
  const { currentStep, signInFlow } = props;

  const signedIn = useMemo(() => {
    const tokenExpiration = token.getTokenExpiration();
    const tokenValid = new Date() < tokenExpiration;
    return tokenValid && currentStep === VALIDATED;
  }, [currentStep]);

  useEffect(() => {
    if (signedIn) {
      signInFlow();
    }
  }, [signedIn, signInFlow]);

  if (signedIn) {
    return <Spinner />;
  }

  return (
    <FullPageLayout>
      <SignIn
        signIn={props.signIn}
        error={props.error}
        isError={props.isError}
        resendEmailOtp={props.resendEmailOtp}
        backToSignIn={props.backToSignIn}
        verifyEmailOtp={props.verifyEmailOtp}
        currentStep={props.currentStep}
      />
    </FullPageLayout>
  );
}

const mapStateToProps = (state) => {
  const { isError, error, currentStep } = state.auth;

  return {
    isError,
    error,
    currentStep: currentStep || 1,
  };
};

const mapDispatchToProps = (dispatch) => ({
  signIn: (values) => dispatch(signIn(values)),
  signInFlow: () => dispatch(signInFlow()),
  verifyEmailOtp: (otp) => dispatch(verifyEmailOtp(otp)),
  resendEmailOtp: (email) => dispatch(resendEmailOtp(email)),
  backToSignIn: () => dispatch(unauthenticated),
});

SignInContainer.propsTypes = {
  signIn: PropTypes.func.isRequired,
  signInFlow: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignInContainer);
